import { render } from "./B2bPageDownloadPdfCmr.vue?vue&type=template&id=9d01451a&scoped=true&lang=pug"
import script from "./B2bPageDownloadPdfCmr.vue?vue&type=script&lang=js"
export * from "./B2bPageDownloadPdfCmr.vue?vue&type=script&lang=js"

import "./B2bPageDownloadPdfCmr.vue?vue&type=style&index=0&id=9d01451a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d01451a"]])

export default __exports__